export const defaultLitmusConversation = {
    "auto_scroll_on_rating_change": true,
    "is_new_component_editor": true,
    "default_device": "desktop",
    "devices":
    {
        "phone":
        {
            "is_touch_enabled": true
        },
        "desktop":
        {
            "is_touch_enabled": false
        }, 
        "tablet":
        {
            "is_touch_enabled": true
        }
    },
    "footer_style":
    {
        "is_per_group": true,
        "hide_logo": false
    },
    "enable_back_button": true,
    "default_language": "english",
    "languages":
    {
        "english":
        {
            "display_name": "English",
            "language": "English",
            "time": 0,
            "labels":
            {
                "label-header": "{{brand.name}}",
                "label_1525332154055k3s6D": "Thank you for your valuable feedback.",
                "label_1525332206041rOrWu": "Thank you for your interest. Sorry, the link is no longer available.",
                "label_1525332234338XmGBe": "Thank you for your interest. You have already submitted your feedback.",
                "label_1525332290182Ixrkd": "Next"
            },
            "key": "english"
        }
    },
    "header":
    {
        "is_fixed": true,
        "label": "label-header",
        "version": "2.0"
    },
    "screens":
    {
        "phone":
        {
            "english": [
            {
                "id": "phone_page_1525332290182",
                "page_title": "Thank you page",
                "fields": [
                {
                    "field_id": "question_1525332154056",
                    "read-only": true,
                    "label": "label_1525332154055k3s6D",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 1,
                "is_last_page": true,
                "do_not_save_on_submit": true
            },
            {
                "id": "phone_page_1525332344288",
                "page_title": "Link expiry page",
                "fields": [
                {
                    "field_id": "question_1525332206041",
                    "read-only": true,
                    "label": "label_1525332206041rOrWu",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 2,
                "expired_flows": true,
                "is_last_page": false,
                "do_not_save_on_submit": true
            },
            {
                "id": "phone_page_1525332357095",
                "page_title": "Response already submitted page",
                "fields": [
                {
                    "field_id": "question_1525332234338",
                    "read-only": true,
                    "label": "label_1525332234338XmGBe",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 3,
                "archive_flows": true,
                "is_last_page": false,
                "do_not_save_on_submit": true
            }]
        },
        "desktop":
        {
            "english": [
            {
                "id": "desktop_page_1525332290182",
                "page_title": "Thank You Page-Desktop",
                "fields": [
                {
                    "field_id": "question_1525332154056",
                    "read-only": true,
                    "label": "label_1525332154055k3s6D",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 1,
                "is_last_page": true,
                "do_not_save_on_submit": true
            },
            {
                "id": "desktop_page_1525332344288",
                "page_title": "Link Expiry Page-Desktop",
                "fields": [
                {
                    "field_id": "question_1525332206041",
                    "read-only": true,
                    "label": "label_1525332206041rOrWu",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 2,
                "expired_flows": true,
                "is_last_page": false,
                "do_not_save_on_submit": true
            },
            {
                "id": "desktop_page_1525332357095",
                "page_title": "Response Already Submitted Page-Desktop",
                "fields": [
                {
                    "field_id": "question_1525332234338",
                    "read-only": true,
                    "label": "label_1525332234338XmGBe",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 3,
                "archive_flows": true,
                "is_last_page": false,
                "do_not_save_on_submit": true
            }]
        },
        "tablet":
        {
            "english": [
            {
                "id": "tablet_page_1525332290182",
                "page_title": "Thank you page-Tablet",
                "fields": [
                {
                    "field_id": "question_1525332154056",
                    "read-only": true,
                    "label": "label_1525332154055k3s6D",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 1,
                "is_last_page": true,
                "do_not_save_on_submit": true
            },
            {
                "id": "tablet_page_1525332344288",
                "page_title": "Link Expiry Page-Tablet",
                "fields": [
                {
                    "field_id": "question_1525332206041",
                    "read-only": true,
                    "label": "label_1525332206041rOrWu",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 2,
                "expired_flows": true,
                "is_last_page": false,
                "do_not_save_on_submit": true
            },
            {
                "id": "tablet_page_1525332357095",
                "page_title": "Response Already Submitted Page-Tablet",
                "fields": [
                {
                    "field_id": "question_1525332234338",
                    "read-only": true,
                    "label": "label_1525332234338XmGBe",
                    "params":
                    {
                        "display": "block",
                        "className": "",
                        "richText": ""
                    },
                    "component_type": "litmus-text-label",
                    "type": "detailed-rating",
                    "has_reactor": false,
                    "do_not_repeat": false
                }],
                "is_rating_page": false,
                "save_on_submit": false,
                "enable_auto_scroll": true,
                "disable_auto_scroll": false,
                "currentIndex": 3,
                "archive_flows": true,
                "is_last_page": false,
                "do_not_save_on_submit": true
            }]
        }
    },
    "flows":
    {
        "phone":
        {
            "english": [
                "phone_page_1525332290182",
                "phone_page_1525332344288",
                "phone_page_1525332357095"
            ]
        },
        "desktop":
        {
            "english": [
                "desktop_page_1525332290182",
                "desktop_page_1525332344288",
                "desktop_page_1525332357095"
            ]
        },
        "tablet":
        {
            "english": [
                "tablet_page_1525332290182",
                "tablet_page_1525332344288",
                "tablet_page_1525332357095"
            ]
        }
    },
    "expired_flows":
    {
        "phone":
        {
            "english": [
                "phone_page_1525332344288"
            ]
        },
        "desktop":
        {
            "english": [
                "desktop_page_1525332344288"
            ]
        },
        "tablet":
        {
            "english": [
                "tablet_page_1525332344288"
            ]
        }
    },
    "archive_flows":
    {
        "phone":
        {
            "english": [
                "phone_page_1525332357095"
            ]
        },
        "desktop":
        {
            "english": [
                "desktop_page_1525332357095"
            ]
        },
        "tablet":
        {
            "english": [
                "tablet_page_1525332357095"
            ]
        }
    },
    "custom_styles": [],
    "custom_scripts": [],
    "fields": [
    {
        "component_id": "5836e59bb3faf4d2b4133e5a",
        "text": "Thank you for your valuable feedback.",
        "question": "Thank you for your valuable feedback.",
        "field_id": "question_1525332154056",
        "component_type": "litmus-text-label",
        "is_primary_rating": false,
        "is_mandatory": false,
        "is_displayed_on_dashboard": true,
        "conversation_type": "label",
        "type": "detailed-rating",
        "label": "label_1525332154055k3s6D",
        "possible_values": [],
        "params":
        {
            "display": "block",
            "className": "",
            "richText": ""
        },
        "hide_label": false,
        "do_not_repeat": false,
        "read-only": true,
        "interaction_type": "label",
        "rating_bar_reactor_allowed": false,
        "read_only": true,
        "old_component_id": "5836e59bb3faf4d2b4133e5a",
        "prop":
        {}
    },
    {
        "component_id": "5836e59bb3faf4d2b4133e5a",
        "text": "Thank you for your interest. Sorry, the link is no longer available.",
        "question": "Thank you for your interest. Sorry, the link is no longer available.",
        "field_id": "question_1525332206041",
        "component_type": "litmus-text-label",
        "is_primary_rating": false,
        "is_mandatory": false,
        "is_displayed_on_dashboard": true,
        "conversation_type": "label",
        "type": "detailed-rating",
        "label": "label_1525332206041rOrWu",
        "possible_values": [],
        "params":
        {
            "display": "block",
            "className": "",
            "richText": ""
        },
        "hide_label": false,
        "do_not_repeat": false,
        "read-only": true,
        "interaction_type": "label",
        "rating_bar_reactor_allowed": false,
        "read_only": true,
        "old_component_id": "5836e59bb3faf4d2b4133e5a",
        "prop":
        {}
    },
    {
        "component_id": "5836e59bb3faf4d2b4133e5a",
        "text": "Thank you for your interest. You have already submitted your feedback.",
        "question": "Thank you for your interest. You have already submitted your feedback.",
        "field_id": "question_1525332234338",
        "component_type": "litmus-text-label",
        "is_primary_rating": false,
        "is_mandatory": false,
        "is_displayed_on_dashboard": true,
        "conversation_type": "label",
        "type": "detailed-rating",
        "label": "label_1525332234338XmGBe",
        "possible_values": [],
        "params":
        {
            "display": "block",
            "className": "",
            "richText": ""
        },
        "hide_label": false,
        "do_not_repeat": false,
        "read-only": true,
        "interaction_type": "label",
        "rating_bar_reactor_allowed": false,
        "read_only": true,
        "old_component_id": "5836e59bb3faf4d2b4133e5a",
        "prop":
        {}
    }]
}